const ProductRoot = 'products';

export const productsPaths = {
  root: ProductRoot,
};
